import { useMutation } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';
import { HttpResponse } from '~/services/types';

export interface CreateBatchRoomRatesParams {
  propertyId: string;
  ratePlanIds: Array<string>;
  roomTypeId: string;
}

export type CreateBatchRoomRatesResponse = HttpResponse<Array<App.RoomRate>>;

export function useCreateBatchRoomRates() {
  return useMutation({
    mutationFn: ({
      propertyId,
      ratePlanIds,
      roomTypeId,
    }: CreateBatchRoomRatesParams): Promise<CreateBatchRoomRatesResponse> =>
      ReservationService.createBatchRoomRates(propertyId, roomTypeId, {
        rate_plan_id: ratePlanIds,
        source: 'admin',
      }) as Promise<CreateBatchRoomRatesResponse>,
  });
}
